/**
 * @module skills
 * The skills that are practised as events (a shot), not as swings at contact or as reps: basketball shooting now, cricket
 * batting next. Each skill is data (ai/skills/<sport>.js); the engine is ai/skill/*.
 *
 * These are NOT the analysis contact ranges in ai/idealAngles (cricket and basketball have those too, for the ghost on an
 * analysed clip). Keep them apart: practice has its own moments, ranges and wording.
 *
 * `status`: "live" (shown), "beta" (shown with a badge), "hidden" (kept in code, not offered, not in the SEO pages).
 */
import { BASKETBALL } from "./basketball.js";
import { CRICKET } from "./cricket.js";

export const SKILLS = { basketball: BASKETBALL, cricket: CRICKET };

export const SKILL_SPORT_LABELS = { basketball: "Basketball", cricket: "Cricket" };

// what a person might call a shot -> the skill key (an alias may only drop detail, never add it)
export const SKILL_ALIASES = {
  basketball: { free_throw: "free_throw", foul_shot: "free_throw", free_throws: "free_throw", jump_shot: "jump_shot", jumper: "jump_shot", mid_range: "jump_shot", three_point: "jump_shot", three_pointer: "jump_shot", shooting: "free_throw" },
  cricket: { forward_defence: "forward_defence", defence: "forward_defence", front_foot_defence: "forward_defence", front_foot_drive: "front_foot_drive", drive: "front_foot_drive", cover_drive: "front_foot_drive", straight_drive: "front_foot_drive", back_foot_defence: "back_foot_defence", batting: "forward_defence", pull: "pull_shot", pull_shot: "pull_shot", hook: "pull_shot", cut: "cut_shot", cut_shot: "cut_shot", square_cut: "cut_shot", sweep: "sweep_shot", sweep_shot: "sweep_shot" },
};

export const getSkill = (sport, key) => SKILLS[sport]?.[key] || null;

/** A skill's cheers as the rep coach reads them: "moment.measure" of a grade item -> phrase key (the config lists them by check key). */
export function skillPraise(skill) {
  const map = {};
  for (const [checkKey, phrase] of Object.entries(skill.praise || {})) {
    const c = skill.checks[checkKey];
    if (c) map[`${c.at}.${c.measure}`] = phrase;
  }
  return map;
}
